// WooCommerce notice → toast bridge.
//
// Woo emits .woocommerce-message / .woocommerce-error / .woocommerce-info
// banners at the top of the cart, checkout, and shop pages after any
// action (cart updated, coupon applied, item removed, etc). They look
// like default Woo chrome — green/red full-width bars. We:
//   1. Hide the original via CSS (the .woocommerce-message rule below)
//   2. On page load, scan the DOM for them, extract the text, and show
//      our existing .cart-toast component instead — same look as the
//      "Added to cart" toast that fires from the single-product page.

function showToast(msg, variant = 'ok') {
    let toastEl = document.querySelector('.cart-toast');
    if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'cart-toast';
        document.body.appendChild(toastEl);
    }
    toastEl.dataset.variant = variant;
    const icon = variant === 'err'
        ? '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h0"/></svg>'
        : '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4 4 10-10"/></svg>';
    toastEl.innerHTML = `
        <span class="cart-toast__icon" aria-hidden="true">${icon}</span>
        <span class="cart-toast__msg">${msg}</span>
    `;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3600);
}

function sweep() {
    // Pick up Woo's banner notices, hand each one to our toast, then
    // remove the original from the DOM so there's no double display.
    const map = [
        ['.woocommerce-message', 'ok'],
        ['.woocommerce-info',    'ok'],
        ['.woocommerce-error',   'err'],
    ];
    map.forEach(([sel, variant]) => {
        document.querySelectorAll(sel).forEach(n => {
            const text = n.textContent.replace(/\s+/g, ' ').trim();
            if (text) showToast(text, variant);
            n.remove();
        });
    });

    // The wrapper that holds notices (added by Woo when WC_Notices runs)
    // sometimes lingers empty — clean it up too.
    document.querySelectorAll('.woocommerce-notices-wrapper').forEach(w => {
        if (!w.textContent.trim()) w.remove();
    });
}

// Initial scan
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
} else {
    sweep();
}

// Re-scan after Woo's AJAX events (cart updates, fragment refreshes
// etc fire 'added_to_cart' / 'removed_from_cart' on document.body via
// jQuery). Listen on the native event bus too in case jQuery isn't
// present.
if (window.jQuery) {
    window.jQuery(document.body).on('added_to_cart removed_from_cart updated_cart_totals updated_wc_div applied_coupon removed_coupon', sweep);
}
document.body.addEventListener('wc_fragments_loaded', sweep);
document.body.addEventListener('wc_fragments_refreshed', sweep);
